import { authHeaders, getRequest, invokeApi, postRequest } from "../components/network/apiclient";
import { gameSessionEndpoint } from "./endpoint";

export const createGameSession = (token, onSuccess, onError, payload) =>
    invokeApi(postRequest(gameSessionEndpoint.createPath(), authHeaders(token), payload), onSuccess, onError);

export const updateGameSession = (token, onSuccess, onError, payload) =>
    invokeApi(postRequest(gameSessionEndpoint.updatePath(), authHeaders(token), payload), onSuccess, onError);

export const deleteGameSession = (token, onSuccess, onError, gameSessionId) =>
    invokeApi(postRequest(gameSessionEndpoint.deletePath(), authHeaders(token), { gameSessionId }), onSuccess, onError);

export const listGameSessions = (token, onSuccess, onError) =>
    invokeApi(getRequest(gameSessionEndpoint.listPath(), authHeaders(token)), onSuccess, onError);

export const fetchGameSessionStats = (token, onSuccess, onError, from, to) =>
    invokeApi(postRequest(gameSessionEndpoint.statsPath(), authHeaders(token), { from, to }), onSuccess, onError);

export const addUserToGameSession = (token, onSuccess, onError, gameSessionId, friendUserId) =>
    invokeApi(postRequest(gameSessionEndpoint.addUserPath(), authHeaders(token), { gameSessionId, friendUserId }), onSuccess, onError);

export const removeUserFromGameSession = (token, onSuccess, onError, gameSessionId, friendUserId) =>
    invokeApi(postRequest(gameSessionEndpoint.removeUserPath(), authHeaders(token), { gameSessionId, friendUserId }), onSuccess, onError);

export const leaveGameSession = (token, onSuccess, onError, gameSessionId) =>
    invokeApi(postRequest(gameSessionEndpoint.leavePath(), authHeaders(token), { gameSessionId }), onSuccess, onError);

export const getGameSessionWithUsers = (token, onSuccess, onError, gameSessionId) =>
    invokeApi(postRequest(gameSessionEndpoint.getWithUsersPath(), authHeaders(token), { gameSessionId }), onSuccess, onError);
